import React from 'react';
import { AltOffering } from '@benzinga/alts-manager';
import { OfferingCard, offeringToCardProps } from './OfferingCard';
import { OfferingCardVariant } from '../types';

export interface Listing extends Omit<AltOffering, 'minInvestment'> {
  minInvestment: string | number;
  projectedReturn?: string;
  openToNonAccredited?: string;
}

export interface ListingPreviewProps {
  listing: AltOffering;
  handleLeadCapture?: () => void;
  variant?: OfferingCardVariant;
  onTagClick?: (label: string, value: string) => void;
  showGetStartedLink?: boolean;
  showProductTake?: boolean;
}

export const ListingPreview: React.FC<ListingPreviewProps> = ({
  handleLeadCapture,
  listing,
  onTagClick,
  showGetStartedLink = false,
  showProductTake = false,
  variant = 'default',
}) => {
  const cardProps = offeringToCardProps(listing);
  return (
    <OfferingCard
      {...cardProps}
      getStartedLink={showGetStartedLink ? listing.affiliateLink : null}
      handleLeadCapture={handleLeadCapture}
      onTagClick={onTagClick}
      variant={showProductTake ? 'full' : variant}
    />
  );
};
